/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./Group.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { GroupProps, GroupState } from "./Group.types";

import Dialog from "components/ThreeKey/Dialogs/Dialog";
import Input from "components/ThreeKey/Input";


class Group extends React.Component<GroupProps, GroupState> {

   constructor(props: GroupProps) {

      super(props);

      this.state = {
         groupName: this.props.data ? this.props.data.name : "",
         groupDescription: this.props.data ? this.props.data.description : ""
      }

   }

   public componentDidMount(): void {
   }

   public componentWillUnmount(): void {
   }

   public componentDidUpdate(prevProps: GroupProps, prevState: GroupState) {
   }

   public render(): React.ReactNode {

      const saveDisabled = (this.props.data?.name === this.state.groupName && this.props.data.description === this.state.groupDescription) || this.state.groupName === "";

      return (

         <Dialog componentName="group-detail" closeOnEscape={true} closeOnOverlayMouseDown={true} onClose={this.onCancel}>

            <div className="group-dialog">

               <div className="item">
                  <strong>Group details</strong>
               </div>

               <div className="item">
                  <label htmlFor="name">Group name:</label>
                  <Input id="name" value={this.state.groupName} onChange={this.onNameChange} autoComplete="off" />
               </div>

               <div className="item">
                  <label htmlFor="desc">Group description:</label>
                  <textarea id="desc" onChange={this.onDescChange} value={this.state.groupDescription} autoComplete="off" />
               </div>

               <div className="buttons">
                  <button data-type="ok" disabled={saveDisabled} onClick={this.onSave}>Save</button>
                  &nbsp;&nbsp;&nbsp;
                  <button data-type="cancel" onClick={this.onCancel}>Canel</button>
               </div>

            </div>

         </Dialog>

      )

   }

   private onNameChange = ((value: string | number) => {
      this.setState({ groupName: value.toString() });
   });

   private onDescChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      this.setState({ groupDescription: e.target.value });
   };

   private onCancel = () => {
      this.props.onClose();
   }

   private onSave = () => {

      if (!this.props.onSave) return;

      this.props.onSave({
         _seq_no: this.props.data._seq_no,
         _primary_term: this.props.data._primary_term,
         companyId: this.props.data.companyId,
         id: this.props.data.id,
         name: this.state.groupName,
         description: this.state.groupDescription
      })

   }

}


const mapStateToProps = (state: {
   sliceName: any, // redux state interface
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            // slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(Group);